const isProduction = process.env.NODE_ENV === "production";

export const server = isProduction
  ? "/api/v2"
  : `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/api/v2`;

export const socketUrl = isProduction
  ? process.env.REACT_APP_SOCKET_URL || ""
  : process.env.REACT_APP_SOCKET_URL || "http://localhost:5000";
